import { jsx as o } from "react/jsx-runtime";
const e = ({
  width: C,
  height: r,
  className: t
}) => /* @__PURE__ */ o(
  "svg",
  {
    className: t,
    fill: "none",
    height: r,
    viewBox: "0 0 18 15",
    width: C,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ o(
      "path",
      {
        d: "M3.489 7.00289L3.512 13.8859M14.488 7.00289L14.511 13.8629M15.86 13.8629L2.14 13.8859M6.256 13.8629V9.19789C6.25626 9.16147 6.27092 9.12662 6.29677 9.10096C6.32262 9.07529 6.35757 9.06089 6.394 9.06089H11.608C11.6442 9.06115 11.6789 9.07567 11.7046 9.10131C11.7302 9.12694 11.7447 9.16164 11.745 9.19789V13.8629M9 13.8629V9.06089M1.523 6.81789L3.512 1.51489H14.393C14.4209 1.51496 14.448 1.52351 14.4709 1.53941C14.4938 1.55531 14.5112 1.5778 14.521 1.60389L16.476 6.81789C16.4837 6.83859 16.4864 6.86086 16.4836 6.88279C16.4809 6.90472 16.4729 6.92567 16.4603 6.94384C16.4478 6.96202 16.431 6.97688 16.4114 6.98716C16.3919 6.99744 16.3701 7.00284 16.348 7.00289H13.116L11.058 5.63089L9 7.00289L6.942 5.63089L4.884 7.00289H1.651C1.6289 7.00284 1.60714 6.99744 1.58757 6.98716C1.56801 6.97688 1.55123 6.96202 1.53865 6.94384C1.52608 6.92567 1.51808 6.90472 1.51536 6.88279C1.51263 6.86086 1.51525 6.83859 1.523 6.81789Z",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
      }
    )
  }
);
export {
  e as Content
};
